import { Card, Grid } from "@material-ui/core";
import React from "react";
import MiniCardWithBgImg from "../../components/MiniCardWithBgImg";
import PlainCard from "../../components/PlainCard";
import "./EightPlainCards.scss";

const SixPlainCards = (props) => {
  return (
    <div className="body-container">
      <Grid>
        <Grid container direction="row" spacing={3}>
          <Grid item xs={12} sm={12} md={4} className="card crd-spc">
            <PlainCard
              HoverCardWithBtnCustomClass="hover-card-bg-odd"
              HoverCardWithBtntitle={
                props.SixHoverCardData.HoverCardWithBtntitle1
              }
              Extracardclassname={props.SixHoverCardData.Extracardclassname}
              HoverCardExtraiconclassname={
                props.SixHoverCardData.HoverCardExtraiconclassname
              }
              HoverCardWithBtnIcon={
                props.SixHoverCardData.HoverCardWithBtnIcon1
              }
              HoverCardWithBtnContent={
                props.SixHoverCardData.HoverCardWithBtnContent1
              }
              HoverCardWithBtnContentClass={
                props.SixHoverCardData.HoverCardWithBtnContentClass
              }
              HoverCardWithBtnIconAlt={
                props.SixHoverCardData.HoverCardWithBtnIconAlt1
              }
              HoverCardIconClass={props.HoverCardIconClass}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className="card crd-spc">
            <PlainCard
              HoverCardWithBtnCustomClass="hover-card-bg-even"
              HoverCardWithBtntitle={
                props.SixHoverCardData.HoverCardWithBtntitle2
              }
              Extracardclassname={props.SixHoverCardData.Extracardclassname}
              HoverCardExtraiconclassname={
                props.SixHoverCardData.HoverCardExtraiconclassname
              }
              HoverCardWithBtnIcon={
                props.SixHoverCardData.HoverCardWithBtnIcon2
              }
              HoverCardWithBtnContent={
                props.SixHoverCardData.HoverCardWithBtnContent2
              }
              HoverCardWithBtnContentClass={
                props.SixHoverCardData.HoverCardWithBtnContentClass
              }
              HoverCardWithBtnIconAlt={
                props.SixHoverCardData.HoverCardWithBtnIconAlt2
              }
              HoverCardIconClass={props.HoverCardIconClass}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className="card crd-spc">
            <PlainCard
              HoverCardWithBtnCustomClass="hover-card-bg-odd"
              HoverCardWithBtntitle={
                props.SixHoverCardData.HoverCardWithBtntitle3
              }
              Extracardclassname={props.SixHoverCardData.Extracardclassname}
              HoverCardExtraiconclassname={
                props.SixHoverCardData.HoverCardExtraiconclassname
              }
              HoverCardWithBtnIcon={
                props.SixHoverCardData.HoverCardWithBtnIcon3
              }
              HoverCardWithBtnContent={
                props.SixHoverCardData.HoverCardWithBtnContent3
              }
              HoverCardWithBtnContentClass={
                props.SixHoverCardData.HoverCardWithBtnContentClass
              }
              HoverCardWithBtnIconAlt={
                props.SixHoverCardData.HoverCardWithBtnIconAlt3
              }
              HoverCardIconClass={props.HoverCardIconClass}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className="card crd-spc">
            <PlainCard
              HoverCardWithBtnCustomClass="hover-card-bg-even"
              HoverCardWithBtntitle={
                props.SixHoverCardData.HoverCardWithBtntitle4
              }
              Extracardclassname={props.SixHoverCardData.Extracardclassname}
              HoverCardExtraiconclassname={
                props.SixHoverCardData.HoverCardExtraiconclassname
              }
              HoverCardWithBtnIcon={
                props.SixHoverCardData.HoverCardWithBtnIcon4
              }
              HoverCardWithBtnContent={
                props.SixHoverCardData.HoverCardWithBtnContent4
              }
              HoverCardWithBtnContentClass={
                props.SixHoverCardData.HoverCardWithBtnContentClass
              }
              HoverCardWithBtnIconAlt={
                props.SixHoverCardData.HoverCardWithBtnIconAlt4
              }
              HoverCardIconClass={props.HoverCardIconClass}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className="card crd-spc">
            <PlainCard
              HoverCardWithBtnCustomClass="hover-card-bg-odd"
              HoverCardWithBtntitle={
                props.SixHoverCardData.HoverCardWithBtntitle5
              }
              Extracardclassname={props.SixHoverCardData.Extracardclassname}
              HoverCardExtraiconclassname={
                props.SixHoverCardData.HoverCardExtraiconclassname
              }
              HoverCardWithBtnIcon={
                props.SixHoverCardData.HoverCardWithBtnIcon5
              }
              HoverCardWithBtnContent={
                props.SixHoverCardData.HoverCardWithBtnContent5
              }
              HoverCardWithBtnContentClass={
                props.SixHoverCardData.HoverCardWithBtnContentClass
              }
              HoverCardWithBtnIconAlt={
                props.SixHoverCardData.HoverCardWithBtnIconAlt5
              }
              HoverCardIconClass={props.HoverCardIconClass}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className="card crd-spc">
            <PlainCard
              HoverCardWithBtnCustomClass="hover-card-bg-even"
              HoverCardWithBtntitle={
                props.SixHoverCardData.HoverCardWithBtntitle6
              }
              Extracardclassname={props.SixHoverCardData.Extracardclassname}
              HoverCardExtraiconclassname={
                props.SixHoverCardData.HoverCardExtraiconclassname
              }
              HoverCardWithBtnIcon={
                props.SixHoverCardData.HoverCardWithBtnIcon6
              }
              HoverCardWithBtnContent={
                props.SixHoverCardData.HoverCardWithBtnContent6
              }
              HoverCardWithBtnContentClass={
                props.SixHoverCardData.HoverCardWithBtnContentClass
              }
              HoverCardWithBtnIconAlt={
                props.SixHoverCardData.HoverCardWithBtnIconAlt6
              }
              HoverCardIconClass={props.HoverCardIconClass}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className="card crd-spc">
            <PlainCard
              HoverCardWithBtnCustomClass="hover-card-bg-odd"
              HoverCardWithBtntitle={
                props.SixHoverCardData.HoverCardWithBtntitle7
              }
              Extracardclassname={props.SixHoverCardData.Extracardclassname}
              HoverCardExtraiconclassname={
                props.SixHoverCardData.HoverCardExtraiconclassname
              }
              HoverCardWithBtnIcon={
                props.SixHoverCardData.HoverCardWithBtnIcon7
              }
              HoverCardWithBtnContent={
                props.SixHoverCardData.HoverCardWithBtnContent7
              }
              HoverCardWithBtnContentClass={
                props.SixHoverCardData.HoverCardWithBtnContentClass
              }
              HoverCardWithBtnIconAlt={
                props.SixHoverCardData.HoverCardWithBtnIconAlt7
              }
              HoverCardIconClass={props.HoverCardIconClass}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className="card crd-spc">
            <PlainCard
              HoverCardWithBtnCustomClass="hover-card-bg-even"
              HoverCardWithBtntitle={
                props.SixHoverCardData.HoverCardWithBtntitle8
              }
              Extracardclassname={props.SixHoverCardData.Extracardclassname}
              HoverCardExtraiconclassname={
                props.SixHoverCardData.HoverCardExtraiconclassname
              }
              HoverCardWithBtnIcon={
                props.SixHoverCardData.HoverCardWithBtnIcon8
              }
              HoverCardWithBtnContent={
                props.SixHoverCardData.HoverCardWithBtnContent8
              }
              HoverCardWithBtnContentClass={
                props.SixHoverCardData.HoverCardWithBtnContentClass
              }
              HoverCardWithBtnIconAlt={
                props.SixHoverCardData.HoverCardWithBtnIconAlt8
              }
              HoverCardIconClass={props.HoverCardIconClass}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className="card crd-spc">
            <Card className="eight-card-bg-hght">
              <MiniCardWithBgImg
                MiniCardBgImg={props.SixHoverCardData.image}
                MiniCardBgImgId="100"
                title={props.SixHoverCardData.title}
                subtitle={props.SixHoverCardData.subTitle}
                variant={props.SixHoverCardData.variant}
                customClassName="three-mini-card-btn mt-20"
                cardCustomClass={props.SixHoverCardData.customClass}
                label={props.SixHoverCardData.label}
                route={props.SixHoverCardData.route}
                tip={props.SixHoverCardData.tip}
                tooltip={props.SixHoverCardData.tooltip}
              />
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default SixPlainCards;
